module.exports = __webpack_public_path__ + "static/media/profesora.cfe4e5b0.svg";